import { Temporal } from "temporal-polyfill";

/**
 * Parse an ISO string (with optional Temporal timezone annotation) into a JS Date.
 * Handles all formats: UTC ("Z"), offset ("-07:00"), and bracket ("[America/Los_Angeles]").
 */
export function parseISOToDate(iso: string): Date {
  return new Date(parseISOToMs(iso));
}

/**
 * Parse an ISO string into epoch milliseconds.
 */
export function parseISOToMs(iso: string): number {
  try {
    return Temporal.Instant.from(iso).epochMilliseconds;
  } catch {
    return Temporal.ZonedDateTime.from(iso).epochMilliseconds;
  }
}
